import type { HttpErrorResponse } from '@angular/common/http';

import type { ActivitiesFiltersParams, TrackingActivity } from '@core/activities-types';
import { createEntityCollectionStore, DEFAULT_SCOPE_NAME, pipeState } from '@core/ngrx-legacy';

import type { NotificationsStore } from '../../types';
import { EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<TrackingActivity>()(
  EntityStoreKey.notifications,
  {
    customActions: adapter => ({
      markAsViewed: (state, payload: number[]) => adapter.markAsPending(state),
      markAsViewedSuccess: state => adapter.markAsLoaded(state),
      markAsViewedFailed: (state, payload: HttpErrorResponse) => adapter.setError(state, payload),

      markAsNotViewed: (state, payload: number[]) => adapter.markAsPending(state),

      markAllViewed: state => adapter.markAsPending(state),
      markAllNotViewed: state => adapter.markAsPending(state),
      markAllViewedSuccess: state => adapter.markAsLoaded(state),
      markAllViewedFailed: (state, payload: HttpErrorResponse) => adapter.setError(state, payload),
      markAllViewedByCandidate: (state, payload: number) => adapter.markAsPending(state),
      markAllViewedByCandidateSuccess: state => adapter.markAsLoaded(state),
      markAllViewedByCandidateFailed: (state, payload: HttpErrorResponse) =>
        adapter.setError(state, payload),
      fetchCollection: (
        state,
        payload: { params: ActivitiesFiltersParams; scope?: string; replace?: boolean },
      ) =>
        pipeState(
          state,
          next => (payload.replace ? adapter.resetScope(next, payload.scope) : next),
          next =>
            adapter.markAsPending(next, {
              scope: payload.scope || DEFAULT_SCOPE_NAME,
              entities: [],
            }),
        ),
      fetchCollectionSuccess: (
        state,
        payload: { data: NotificationsStore; scope?: string; replace?: boolean },
      ) =>
        pipeState(
          state,
          next => (payload.replace ? adapter.setMany(next, [], { scope: payload.scope }) : next),
          next => adapter.addMany(next, payload.data.activities, { scope: payload.scope }),
          next =>
            adapter.markAsLoaded(next, {
              scope: payload.scope || DEFAULT_SCOPE_NAME,
              entities: payload.data.activities.map(e => e.id),
            }),
        ),
    }),
  },
);

export {
  actions as NotificationsActions,
  selectors as NotificationsSelectors,
  reducer as NotificationsReducer,
  namespace as NotificationsNamespace,
};
